import { combineReducers } from 'redux'

import buyer from './buyerReducer'
import creator from './creatorReducer'
import inflowHistory from './inflowHistoryReducer'
import itemEntry from './itemEntryReducer'
import landing from './landingReducer'
import outflowHistory from './outflowHistoryReducer'
import sellerHistory from './sellerHistoryReducer'
import sms from './smsReducer'
import tapPay from './tapPayReducer'
import ui from './uiReducer'
import user from './userReducer'
import vendor from './vendorReducer'
import withdraw from './withdrawReducer'

export default combineReducers({
  buyer,
  creator,
  inflowHistory,
  itemEntry,
  landing,
  outflowHistory,
  sellerHistory,
  sms,
  tapPay,
  ui,
  user,
  vendor,
  withdraw,
})
